/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentUseCasesControllerGetRemainingProcessingStepsQueryResponse, DocumentUseCasesControllerGetRemainingProcessingStepsPathParams, DocumentUseCasesControllerGetRemainingProcessingSteps401, DocumentUseCasesControllerGetRemainingProcessingSteps403 } from "../../models/documentUseCasesController/DocumentUseCasesControllerGetRemainingProcessingSteps";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { documentUseCasesControllerGetRemainingProcessingSteps } from "../../clients/document-use-casesService/documentUseCasesControllerGetRemainingProcessingSteps";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const documentUseCasesControllerGetRemainingProcessingStepsQueryKey = (processingId: DocumentUseCasesControllerGetRemainingProcessingStepsPathParams["processingId"]) => [{
  url: '/api/v1/documents/processings/:processingId/steps/remaining',
  params: {
    processingId: processingId
  }
}] as const;
export type DocumentUseCasesControllerGetRemainingProcessingStepsQueryKey = ReturnType<typeof documentUseCasesControllerGetRemainingProcessingStepsQueryKey>;
export function documentUseCasesControllerGetRemainingProcessingStepsQueryOptions(processingId: DocumentUseCasesControllerGetRemainingProcessingStepsPathParams["processingId"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = documentUseCasesControllerGetRemainingProcessingStepsQueryKey(processingId);
  return queryOptions<DocumentUseCasesControllerGetRemainingProcessingStepsQueryResponse, ResponseErrorConfig<DocumentUseCasesControllerGetRemainingProcessingSteps401 | DocumentUseCasesControllerGetRemainingProcessingSteps403>, DocumentUseCasesControllerGetRemainingProcessingStepsQueryResponse, typeof queryKey>({
    enabled: !!processingId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return documentUseCasesControllerGetRemainingProcessingSteps(processingId, config);
    }
  });
}

/**
 * @description Returns steps that are still in progress or yet to be run (RUNNING, RETRYING, PENDING, RUNNABLE, FAILING) as a JSON:API array.
 * @summary Get remaining steps for a processing workflow
 * {@link /api/v1/documents/processings/:processingId/steps/remaining}
 */
export function useDocumentUseCasesControllerGetRemainingProcessingSteps<TData = DocumentUseCasesControllerGetRemainingProcessingStepsQueryResponse, TQueryData = DocumentUseCasesControllerGetRemainingProcessingStepsQueryResponse, TQueryKey extends QueryKey = DocumentUseCasesControllerGetRemainingProcessingStepsQueryKey>(processingId: DocumentUseCasesControllerGetRemainingProcessingStepsPathParams["processingId"], options: {
  query?: Partial<QueryObserverOptions<DocumentUseCasesControllerGetRemainingProcessingStepsQueryResponse, ResponseErrorConfig<DocumentUseCasesControllerGetRemainingProcessingSteps401 | DocumentUseCasesControllerGetRemainingProcessingSteps403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? documentUseCasesControllerGetRemainingProcessingStepsQueryKey(processingId);
  const query = useQuery({
    ...documentUseCasesControllerGetRemainingProcessingStepsQueryOptions(processingId, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<DocumentUseCasesControllerGetRemainingProcessingSteps401 | DocumentUseCasesControllerGetRemainingProcessingSteps403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}